import { Helmet } from "react-helmet-async";

import { formatPageTitle } from "@/lib/seo/metadata";

type PageTitleProps = {
  /** Page title, templated as `%s | Evangelist`. Omit to use the default site title. */
  title?: string;
};

/**
 * Sets the browser-tab `<title>` for pages that don't render a full `<SeoHead>`
 * (admin, creator, and campaign-launch surfaces). Thin wrapper around Helmet.
 */
export const PageTitle = ({ title }: PageTitleProps) => (
  <Helmet>
    <title>{formatPageTitle(title)}</title>
  </Helmet>
);
